import React from "react";
import logo from "../../../assets/images/inc-logo.png";
import customerSelectImg from "../../../assets/images/customers-select.png";
import "../../../assets/css/style.css"; // Make sure your CSS is correctly scoped or loaded

const CustomerPage = () => {
  return (
    <>
      <div className="headerpolicy">
        <div className="container">
          <img src={logo} alt="INC Logo" />
        </div>
      </div>

      <div className="main-wrapper">
        <div className="container">
          <h3 className="inc-heading">Customers</h3>

          <h4 className="inc-blue-heading">Customers overview</h4>
          <p>
            A Customer is a separate business entity, individual, or
            organization that purchases or uses tenant devices and assets. The
            Customer may have multiple users and millions of devices and assets.
          </p>

          <h4 className="inc-blue-heading">Customers overview</h4>
          <p>
            A Customer is a separate business entity, individual, or
            organization that purchases or uses tenant devices and assets. The
            Customer may have multiple users and millions of devices and assets.
          </p>

          <ol>
            <li>
              A Customer is a separate business entity, individual, or
              organization that purchases or uses tenant devices and assets.
              <img src={customerSelectImg} alt="Customer Selection" />
            </li>
            <li>
              A Customer is a separate business entity, individual, or
              organization that purchases or uses tenant devices and assets.
            </li>
            <li>
              A Customer is a separate business entity, individual, or
              organization that purchases or uses tenant devices and assets.
            </li>
          </ol>

          <ul>
            <li>
              A Customer is a separate business entity, individual, or
              organization that purchases or uses tenant devices and assets.
            </li>
            <li>
              A Customer is a separate business entity, individual, or
              organization that purchases or uses tenant devices and assets.
            </li>
            <li>
              A Customer is a separate business entity, individual, or
              organization that purchases or uses tenant devices and assets.
            </li>
          </ul>

          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">IMPORTANT:</h4>
            <p>
              If you delete the Customer, all the data related to this role, as
              well as the level itself, will be lost.
            </p>
          </div>

          <h4 className="inc-blue-heading">Customers overview</h4>
          <p>
            A Customer is a separate business entity, individual, or
            organization that purchases or uses tenant devices and assets. The
            Customer may have multiple users and millions of devices and assets.
          </p>
          <img
            src={customerSelectImg}
            alt="Customer View"
            className="help-img"
          />
        </div>
      </div>

      <footer>
        <div className="container">
          Powered by{" "}
          <a
            href="https://www.vvdntech.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            VVDN Technologies
          </a>
        </div>
      </footer>
    </>
  );
};

export default CustomerPage;
